




import React, { createContext, useState, useEffect } from 'react';
import { flightsData, hotelsData, carsData} from './data';


const AppContext = createContext(null);


const AppContextProvider = ({ children }) => {
 
  const [departureLocation, setDepartureLocation] = useState('');
    useEffect(() => {
    
    const storedDepartureLocation = localStorage.getItem('departureLocation');
    if (storedDepartureLocation) setDepartureLocation(storedDepartureLocation);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('departureLocation', departureLocation);
  }, [departureLocation]);


  const [arrivalLocation, setArrivalLocation] = useState('');

  useEffect(() => {
    
    const storedArrivalLocation = localStorage.getItem('arrivalLocation');
    if (storedArrivalLocation) setArrivalLocation(storedArrivalLocation);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('arrivalLocation', arrivalLocation);
  }, [arrivalLocation]);

  const [hotelLocation, setHotelLocation] = useState('');
  useEffect(() => {
    const storedHotelLocation = localStorage.getItem('hotelLocation');
    if (storedHotelLocation) setHotelLocation(storedHotelLocation);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('hotelLocation', hotelLocation);
  }, [hotelLocation]);
  const [departureDate, setDepartureDate] = useState(() => {
    const storedDepartureDate = localStorage.getItem('departureDate');
    return storedDepartureDate ? new Date(storedDepartureDate) : new Date();
  });

  useEffect(() => {
    localStorage.setItem('departureDate', departureDate.toISOString());
  }, [departureDate]);

  const [carLocation, setCarLocation] = useState('');

  useEffect(() => {
    const storedCarLocation = localStorage.getItem('carLocation');
    if (storedCarLocation) setCarLocation(storedCarLocation);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('carLocation', carLocation);
  }, [carLocation]);
  
  const [arrivalDate, setArrivalDate] = useState(() => {
    const storedArrivalDate = localStorage.getItem('arrivalDate');
    return storedArrivalDate ? new Date(storedArrivalDate) : new Date();
  });

  useEffect(() => {
    localStorage.setItem('arrivalDate', arrivalDate.toISOString());
  }, [arrivalDate]);

  const [checkInDate, setCheckInDate] = useState(() => {
    const storedCheckInDate = localStorage.getItem('checkInDate');
    return storedCheckInDate ? new Date(storedCheckInDate) : new Date();
  });

  useEffect(() => {
    localStorage.setItem('checkInDate', checkInDate.toISOString());
  }, [checkInDate]);


  const [checkOutDate, setCheckOutDate] = useState(() => {
    const storedCheckOutDate = localStorage.getItem('checkOutDate');
    return storedCheckOutDate ? new Date(storedCheckOutDate) : new Date();
  });

  useEffect(() => {
    localStorage.setItem('checkOutDate', checkOutDate.toISOString());
  }, [checkOutDate]);

  const [pickUpDate, setPickUpDate] = useState(() => {
    const storedPickUpDate = localStorage.getItem('pickUpDate');
    return storedPickUpDate ? new Date(storedPickUpDate) : new Date();
  });

  useEffect(() => {
    localStorage.setItem('pickUpDate', pickUpDate.toISOString());
  }, [pickUpDate]);

  const [pickUpTime, setPickUpTime] = useState('');
  useEffect(() => {
    const storedPickUpTime = localStorage.getItem('pickUpTime');
    if (storedPickUpTime) setPickUpTime(storedPickUpTime);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('pickUpTime', pickUpTime);
  }, [pickUpTime]);



  const [trip, setTrip] = useState('');
  useEffect(() => {
    const storedTrip = localStorage.getItem('Trip');
    if (storedTrip) 
    setTrip(storedTrip);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('trip', trip);
  }, [trip]);

  const [flightClass, setFlightClass] = useState('');
  useEffect(() => {
    const storedFlightClass = localStorage.getItem('flightClass');
    if (storedFlightClass) setFlightClass(storedFlightClass);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('flightClass', flightClass);
  }, [flightClass]);



  const [passenger, setPassenger] = useState('');
  useEffect(() => {
    const storedPassenger = localStorage.getItem('passenger');
    if (storedPassenger) setPassenger(storedPassenger);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('passenger', passenger);
  }, [passenger]);

  const [carClass, setCarClass] = useState('');
  useEffect(() => {
    const storedCarClass = localStorage.getItem('carClass');
    if (storedCarClass) setCarClass(storedCarClass);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('carClass', carClass);
  }, [carClass]);


  const [carType, setCarType] = useState('');
  useEffect(() => {
    const storedCarType = localStorage.getItem('carType');
    if (storedCarType) setCarType(storedCarType);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('carType', carType);
  }, [carType]);


  const [adultNo, setAdultNo] = useState('');
  useEffect(() => {
    const storedAdultNo = localStorage.getItem('adultNo');
    if (storedAdultNo) setAdultNo(storedAdultNo);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('adultNo', adultNo);
  }, [adultNo]);

  const [daysNo, setDaysNo] = useState('');
  useEffect(() => {
    const storedDaysNo = localStorage.getItem('daysNo');
    if (storedDaysNo) setDaysNo(storedDaysNo);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('daysNo', daysNo);
  }, [daysNo]);

      
  const [childrenNo, setChildrenNo] = useState('');
  useEffect(() => {
    const storedChildrenNo = localStorage.getItem('childrenNo');
    if (storedChildrenNo) setChildrenNo(storedChildrenNo);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('childrenNo', childrenNo);
  }, [childrenNo]);
  
  const [rooms, setRooms] = useState('');
  useEffect(() => {
    const storedRooms = localStorage.getItem('rooms');
    if (storedRooms) setRooms(storedRooms);
  }, []);

  useEffect(() => {
    
    localStorage.setItem('rooms', rooms);
  }, [rooms]);


  // Create the context value object
  const contextValue = {
    departureLocation,
    setDepartureLocation,
    arrivalLocation,
    setArrivalLocation,
    hotelLocation, setHotelLocation,
    departureDate, setDepartureDate,arrivalDate, setArrivalDate, checkInDate, setCheckInDate, checkOutDate, setCheckOutDate, trip, setTrip,
    flightClass, setFlightClass,
    passenger, setPassenger,
    adultNo, setAdultNo,
    childrenNo, setChildrenNo,
    rooms, setRooms,carsData,carClass, setCarClass, carType, setCarType, carLocation, setCarLocation, pickUpDate, setPickUpDate, pickUpTime, setPickUpTime,daysNo, setDaysNo, flightsData,hotelsData,
    selectedDeparture: departureLocation,
  selectedArrival: arrivalLocation,
  selectedHotelLocation: hotelLocation,
  selectedDepartureDate: departureDate,
  selectedArrivalDate: arrivalDate,
  selectedCheckInDate: checkInDate,
  selectedCheckOutDate: checkOutDate,
  selectedTrip: trip,
  selectedFlightClass: flightClass,
  selectedPassenger: passenger,
  selectedAdultNo: adultNo,
  selectedChildrenNo: childrenNo,
  selectedRooms: rooms,
   selectedCarType: carType,
   selectedCarClass: carClass,
   selectedCarLocation: carLocation,
   selectedPickUpTime: pickUpTime,
   selectedPickUpDate: pickUpDate,
   selectedDaysNo:daysNo,
  };

  

  // Render the provider with the context value
  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
export { AppContextProvider };
